import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material'; // Import InputAdornment for potential future use or consistency
import { SmartFormStates } from './SmartForm';
import ErrorWrapper from '@component/ErrorWrapper';
import { syncValidatorResults } from "@component/smartForm/validatorUtils"
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import { formatDateOnly } from '@utils/timeUtil'; // Adjust the import path as needed

const SmartDateInput = ({
  field,
  label,
  value,
  onChange,
  isEdit,
  sx = {},
  renderView,
  editable = true,
  validator,
  validatorResults,
  setValidatorResults,
  formState,
  startIcon, // <--- Add this prop
  ...props
}) => {
  const [showError, setShowError] = useState(false);
  const [validatorResult, setValidatorResult] = useState('');

  useEffect(() => {
    setShowError(formState === SmartFormStates.SAVING);
  }, [formState]);

  useEffect(() => {
    if (validator) {
      const validatorResult = validator(value);
      syncValidatorResults(validatorResults, setValidatorResults, !validatorResult, label)
      setValidatorResult(validatorResult)
    }

  }, [value, validator, validatorResults, setValidatorResults, label]) // Added dependencies for useEffect

  const handleChange = (newValue) => {
    var isoString
    try{
      isoString= newValue ? newValue.toISOString() : null;
    }
    catch{
      isoString = null
    }finally{
      onChange(field, isoString);
    }
  };

  const parsedDate = value ? dayjs(value) : null;

  return (
    <Box sx={sx}>
      {!isEdit || !editable ? (
        renderView ? (
          renderView(value)
        ) : (
          <>
            {label && <Typography
              variant="caption"
              component="div"
              sx={{
                color: 'text.secondary',
                fontSize: '0.75rem',
                lineHeight: 1.66,
                mb: 0.5
              }}
            >
              {label}
            </Typography>
            }
            <Box sx={{ display: 'flex', alignItems: 'center' }}> {/* Flex container for icon and text */}
              {startIcon && ( // <--- Conditionally render startIcon
                <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                  {startIcon}
                </Box>
              )}
              <Typography variant="body1">
                {value ? formatDateOnly(value, true) : '-'}
              </Typography>
            </Box>
          </>
        )
      ) : (
        <ErrorWrapper message={validatorResult} showMessage={showError}>
          <DatePicker
            label={label}
            value={parsedDate}
            onChange={handleChange}
            format="DD.MM.YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                variant: 'outlined',
                sx: {
                  '& .MuiInputBase-root': {
                    mt: 0.75, // add margin to the input inside
                  },
                },
                // No startAdornment here for edit mode
              },
            }}
            {...props}
          />
        </ErrorWrapper>
      )}
    </Box>
  );
};

export default SmartDateInput;